module.exports = __webpack_public_path__ + "static/media/sample-audio.ac93e13a.mp3";